<template>
  <div>
    <v-menu
        left
        offset-x
        :nudge-left="vt.nudgeLeft"
        ref="menu1"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        max-width="290px"
        min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-model="model"
            :label="vt.label"
            :hint="range? `yyyy-mm-dd, yyyy-mm-dd` : `yyyy-mm-dd`"
            append-icon="mdi-calendar"
            v-bind="attrs"
            dense
            outlined
            max="9999-12-31"
            v-on="on"
            clearable
            @click:clear="vt.filter=null"
        >
        </v-text-field>
      </template>
      <v-date-picker
          v-model="model"
          no-title
          :range="range"
      >
        <template v-slot:default>
          <v-btn small
                 @click="close()"
                 style="text-transform: none!important;">Zamknij
          </v-btn>
          <v-spacer/>
          <v-btn small
                 color="success"
                 @click="menu=false"
                 style="text-transform: none!important;">Zapisz
          </v-btn>
        </template>
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "DataRange",
  props: ['vt', "range", "isoFormat"],
  data() {
    return {
      menu: false,
      model: null,
    }
  },
  watch: {
    "model": function () {
      if(this.model == null){
        this.model = null
      }
      if (this.model.length === 0) {
        this.model = null
      }
      if (this.model.trim().length === 10) {
        if (this.isoFormat) {
          this.vt.filter = new Date(this.model).toISOString()
        } else {
          this.vt.filter = this.model
        }
      }
    },
    "vt.filter"() {
      if (this.vt.filter == null) {
        this.model = null
      }
    }
  },
  methods: {
    close() {
      this.menu = false
      this.model = null;
    }
  }
}
</script>
<style scoped lang="css">
>>> .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
